<template>
  <div class="md-layout-item">
    <form class="modal-content modal-content--in-group trackers_form">
      <div class="rejected_box invalid_color"
           v-if="contractData.rejectReason">
        <div>{{ $t("rejectModal.rejectReason") }}:</div>
        <div class="reason_text">{{ contractData.rejectReason }}</div>
      </div>
      <div class="md-layout">
        <div class="md-layout-item">
          <p class="form_label_head">
            {{ $t("trackPay.trackersForm.trackingDevice") }}
          </p>
          <div class="text_left">
            {{ $t("trackPay.trackersForm.trackingDeviceTip1") }}
          </div>
          <p class="text_left">
            {{ $t("trackPay.trackersForm.trackingDeviceTip2") }}
          </p>
          <div class="flex">
            <div class="flex_1 margin_r">
              <div class="flex_1 margin_r">
                <md-field :class="[{ 'md-error': errors.has('deviceProfileId') }]">
                  <label> {{ $t("trackPay.trackersForm.tracker") }} </label>
                  <TbSelect
                    v-model="form.shipment.deviceProfileId"
                    data-vv-name="deviceProfileId"
						        v-validate="modelValidations.deviceProfileId"
                    :search-allow="true"
                    :disabled="isDisabled()"
                    :required="true"
                    :options="trackerOption"
                    options-value-field="value"
                    options-display-field="label"
                  />
                  <span v-if="errors.has('deviceProfileId')" class="validation-error">{{ errors.first('deviceProfileId') }}</span>
                </md-field>
              </div>
            </div>
            <div class="flex_1 margin_r"></div>
          </div>
          <div class="text_left configuration">
            <p class="form_label_head">
              {{ $t("trackPay.trackersForm.configuration") }}
            </p>
            <md-checkbox v-model="form.isLocation" :disabled=true>
              {{ $t("trackPay.trackersForm.location") }}
            </md-checkbox>
            <br />

			<div style="position: relative; ">
				<div style="width: 100%; opacity: 80%">
					<md-checkbox v-model="form.isTemperature" :disabled="isDisabled()">
						{{ $t("trackPay.trackersForm.temperature") }}
					</md-checkbox>
					<SliderBox
						:initValue="form.temperature"
						:disabled="isDisabled()"
						@changeSlider="changeSlider"
						sliderType="temperature"
					></SliderBox>
					<br />
					<md-checkbox v-model="form.isShock" :disabled="isDisabled()">
						{{ $t("trackPay.trackersForm.shock") }}
					</md-checkbox>
					<br />
					<div>
						<div>{{ $t("trackPay.trackersForm.dataRate") }}</div>
						<md-radio
							v-for="(item, index) in rateList"
							:key="index"
							:disabled="isDisabled()"
							v-model="form.dataRate"
							:value="item"
						>
							{{ item }}
						</md-radio>
						<span class="span_unit"> Hz</span>
					</div>
					<br />
					<div>
						<p>{{ $t("trackPay.trackersForm.intensity") }}</p>
						<SliderBox
							:initValue="form.intensity"
							sliderType="intensity"
							:disabled="isDisabled()"
							@changeSlider="changeSlider"
							unit="g"
							:showFrom="false"
						></SliderBox>
					</div>
					<br />
					<div>
						<p>{{ $t("trackPay.trackersForm.duration") }}</p>
						<SliderBox
							sliderType="duration"
							:initValue="form.duration"
							:disabled="isDisabled()"
							unit="ms"
							@changeSlider="changeSlider"
							:showFrom="false"
						></SliderBox>
					</div>
					<br />
				</div>
				<div style="position: absolute;  top: 0;  left: 0; width: 100%; height: 100%; opacity: 30%;background-color: #a0a4a9">
				</div>
				<div style="position: absolute;  top: 0;  left: 0; width: 100%; height: 100%;">
					<p style="font-size: 24px; margin-top: 27%; text-align: center;"><b>{{$t("trackPay.trackersForm.availableSoon")}}</b></p>
				</div>
			</div>
          </div>
        </div>
      </div>
    </form>
    <div class="flex flex_between margin_top">
      <md-button class="md-blank" @click="back">{{ $t("common.button.back") }}</md-button>
      <md-button @click="next" :class="{ 'md-primary': isFormValid }"
        >{{ $t("common.button.next") }}
      </md-button>
    </div>
  </div>
</template>

<script>
import {validateForm, validateRequiredFields} from "src/validation/validation";
import {enumDef} from "src/common/enumDefs";
import SliderBox from "./SliderBox.vue";
import {trackPayApi} from "../../../common/api/trackPayApi";

export default {
  props: {
    contractData: { type: Object },
    readOnly: Boolean,
    isEditMode: Boolean
  },
  components: {
    SliderBox,
  },
  data() {
    return {
      modelValidations: {
        deviceProfileId: {
          required: true
        }
      },
      form: {
        shipment: {
          deviceProfileId: ""
        }
      },
      debtorDisabled: false,
      showRegistrationNumber: true,
      enumDef: enumDef,
      trackerOption: [],
      rateList: [1600, 400, 200, 100, 50, 25],
    };
  },
  mounted() {
    this.form.shipment = { ...this.contractData.shipment };
    this.form.isLocation = true;
  },
  methods: {
    loadTrackerDevices(productGroup, modesOfTransport) {
      let body = {
        pgId: productGroup,
        modesOfTransport: modesOfTransport ? modesOfTransport.filter(mode => mode.vModel == true).map(mode => mode.key) : null
      }
      trackPayApi.seller.getDeviceProfiles(body)
          .then((res) => {
            this.trackerOption = res.map(item => {
              let option = {
                value: item.id,
                label: item.id
              };
              return option
            });
          })
          .catch(err => this.toast("Error getting device profiles for product group " + productGroup + ": " + err));
    },
    changeSlider(data) {
      this.form[data.sliderType] = data.value;
    },
    getData() {
      return this.form;
    },
    isDisabled() {
      let disabled = false;
      if (this.readOnly) {
        disabled = true;
      }

      return disabled;
    },
    validate() {
      return validateForm(this, this.$validator);
    },
    next() {
      this.validate()
        .then(() => {
          this.$emit("next");
        })
        .catch(this.toast);
    },
    back() {
      this.$emit("back");
    },
    close() {
      this.$emit("close");
    },
  },
  computed: {
    isFormValid() {
      return validateRequiredFields(this.form, this.modelValidations);
    }
  }
};
</script>
<style lang="scss" scoped>
.configuration {
  margin-top: 30px;
}
.trackers_form {
	// max-height: calc(100vh - 350px) !important;
}
</style>
